// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class PlanningRollupCell {
  readonly plantId: string;
  readonly planningNodeId: string;
  readonly isTopDown: boolean;
  readonly planningProductId: string;
  readonly classification: Enums.PlanningProductClassification;
  readonly planningPeriodId: string;
  readonly tons: string;
  readonly asp: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.planningNodeId = data.planningNodeId === undefined ? NIL_UUID : data.planningNodeId;
    this.isTopDown = data.isTopDown === undefined ? false : data.isTopDown;
    this.planningProductId =
      data.planningProductId === undefined ? NIL_UUID : data.planningProductId;
    this.classification =
      data.classification === undefined
        ? Enums.PlanningProductClassification.Aggregates
        : data.classification;
    this.planningPeriodId = data.planningPeriodId === undefined ? NIL_UUID : data.planningPeriodId;
    this.tons = data.tons === undefined ? '0' : data.tons;
    this.asp = data.asp === undefined ? null : data.asp;
  }

  static zero(): PlanningRollupCell {
    const zeroValues: ExcludeMethodsDeep<PlanningRollupCell> = {
      plantId: NIL_UUID,
      planningNodeId: NIL_UUID,
      isTopDown: false,
      planningProductId: NIL_UUID,
      classification: Enums.PlanningProductClassification.Aggregates,
      planningPeriodId: NIL_UUID,
      tons: '0',
      asp: null,
    };
    return new PlanningRollupCell(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningRollupCellWireFormat = {
  plantId: string;
  planningNodeId: string;
  isTopDown: boolean;
  planningProductId: string;
  classification: string;
  planningPeriodId: string;
  tons: string;
  asp: string | null;
};

type NewPlanningRollupCellProps = PartialDeep<PlanningRollupCell, { recurseIntoArrays: true }>;
export const NewPlanningRollupCell: (props: NewPlanningRollupCellProps) => PlanningRollupCell = (
  props,
) => new PlanningRollupCell(props);

type NewPlanningRollupCellFromWireFormatProps = PartialDeep<
  PlanningRollupCellWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningRollupCellFromWireFormat: (
  props: NewPlanningRollupCellFromWireFormatProps,
) => PlanningRollupCell = (props) => new PlanningRollupCell(props);
